import { BetTypes } from "../../../types";
import { isSystemBet, isCastBet, isTeaserBet } from "../../common";
export const getBetType = (bet) => {
    if (isSystemBet(bet.type)) {
        return BetTypes.System;
    }
    if (isCastBet(bet.type)) {
        return BetTypes.CastBet;
    }
    if (isTeaserBet(bet.type)) {
        return BetTypes.Teaser;
    }
    return BetTypes[bet.type];
};
//# sourceMappingURL=getBetType.js.map